/**
 * @module  experience/shared-browse
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';

// Services
import { LoggerService } from '@core/logger/services/logger.service';

// Interfaces
import { BrowseEntryConfigData } from '@core/aem/interfaces/common/browse-entry.interface';
import {
  CreditLevelEnum,
  SHARED_BROWSE_CONSTANTS,
  SHARED_BROWSE_COMPONENTS,
} from '@experience/shop/shared-browse/constants/shared-browse.constants';
import { CreditEntryChangeInterface } from '@experience/shop/shared-browse/interfaces/credit-entry-change.interface';

@Component({
  selector: 'tmo-credit',
  templateUrl: './credit.component.html',
})
export class CreditComponent implements OnInit, OnDestroy {
  /**
   * Configurable AEM data from parent component
   */
  @Input() public creditConfigurableData: BrowseEntryConfigData;
  /** Event emitted when credit is selected
   * It emits the 'Event' object.
   */
  @Output() public onCreditSelect: EventEmitter<CreditEntryChangeInterface>;

  /**
   * variable to hold selectedCreditLevel
   */
  public selectedCreditLevel: string;
  /**
   * temporary variable to hold boolean for whether credit selection is needed. On data update, remove/replace
   */
  public eventTriggered: boolean;

  constructor(private logger: LoggerService) {
    this.onCreditSelect = new EventEmitter();
    this.eventTriggered = true;
  }
  /**
   * Event handler for radio button selection
   */
  public setCreditLevel(creditLevel: string): void {
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.CREDIT,
      'Entering with setCreditLevel() in ' +
        SHARED_BROWSE_COMPONENTS.CREDIT +
        '. input creditLevel: ' +
        creditLevel
    );
    const creditLevelEnumVal = CreditLevelEnum[creditLevel];
    this.selectedCreditLevel = creditLevel;
    this.onCreditSelect.emit({ selectedCreditLevel: creditLevelEnumVal });
  }
  /**
   * Initialize default value of radio button
   */
  public ngOnInit(): void {
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.CREDIT,
      ' Entering ngOnInit() in ' + SHARED_BROWSE_COMPONENTS.CREDIT
    );
    this.selectedCreditLevel = SHARED_BROWSE_CONSTANTS.EXCELLENT_CREDIT;
  }

  public ngOnDestroy(): void {
    this.logger.debug(
      SHARED_BROWSE_CONSTANTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.CREDIT,
      ' unsubscribes from all subscriptions with ngOnDestroy() in ' +
        SHARED_BROWSE_COMPONENTS.CREDIT
    );
  }
}
